import { ReactComponent as Splat } from './splat.svg'
import './splat.css'

export default function Loader() {
    return <Splat className='splat' />
}
